import { toast } from "react-toastify";
import { BaseButton } from "../components/Button/BaseButton.tsx";

export const notifier = {
  error: (message: string) =>
    toast.error(message, { className: "toast bg-[#fc2e2d] text-white" }),
  success: (
    message: string,
    button?: {
      message: string;
      onClick: () => void;
    },
  ) =>
    toast.success(
      <div className="flex-row gap-100 items-center">
        {message}
        {button && (
          <BaseButton className="text-secondary" onClick={button.onClick}>
            {button.message}
          </BaseButton>
        )}
      </div>,
      {
        className: "toast bg-[#86efac] text-primary",
      },
    ),
};
